import { inject, Injectable } from '@angular/core';
import { SwitchingProfileDisplay } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import { HeaderFooterMachCoreContentService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { SwitchProfileAdapterService } from '../../adapters/switch-profile/switch-profile-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class SwitchProfileFacadeService {
  headerFooterContent = inject(HeaderFooterMachCoreContentService);

  adapter = inject(SwitchProfileAdapterService);

  switchingProfileDetails$ = new BehaviorSubject<SwitchingProfileDisplay>(
    {} as SwitchingProfileDisplay
  );

  init(): void {
    this.headerFooterContent
      .getHeaderFooterMachCoreContent$()
      .pipe(take(1))
      .subscribe((content) => {
        this.switchingProfileDetails$.next(this.adapter.getContent(content));
      });
  }
}
